import { IQuery, ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ICacheSCLSearchConfigCommandModel {
  requests: Record<string, Array<ng.IPromise<IQuery[]>>>;
}

export type CacheSCLSearchConfigCommandModel = ITypedModel<ICacheSCLSearchConfigCommandModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngCacheSCLSearchConfigCommandModel',
  () =>
    new Model<ICacheSCLSearchConfigCommandModel>({
      requests: {}
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/models/cache_scl_search_config_command_model.ts